import { connectionDisconnect, connectionFailed, connectionSuccess, connectionWillConnect, getConnection } from "../../features/base/connection";
import JitsiMeetJS, { isFatalJitsiConnectionError, JitsiConnectionEvents } from "../../features/base/lib-jitsi-meet";

const type = "jitsi";

class Connection {
    constructor() {
        this.connection = null;
        this.connecting = null;
        this.handler = null;
    }

    init(handler) {
        this.handler = handler;
    }

    _handlerConnectionEvent(connection) {
        const { dispatch } = APP.store;

        connection.addEventListener(
            JitsiConnectionEvents.CONNECTION_ESTABLISHED, handleConnectionEstablished.bind(this));
        connection.addEventListener(
            JitsiConnectionEvents.CONNECTION_FAILED, handleConnectionFailed.bind(this));
        connection.addEventListener(
            JitsiConnectionEvents.CONNECTION_DISCONNECTED, handlerDisconnection.bind(this));

        function handlerDisconnection(e, message) {
            this.connecting = false;
            this.connection = null;
            this.handler.setConnect(null);

            dispatch(connectionDisconnect(type));
            unsubscribe();
        }

        function handleConnectionFailed(error, message, credentials, details) {
            this.connecting = false;
            this.connection = null;
            this.handler.setConnect(null);

            dispatch(connectionFailed(message, type));

            if (isFatalJitsiConnectionError(error)) {
                connection.removeEventListener(
                    JitsiConnectionEvents.CONNECTION_FAILED,
                    handleConnectionFailed);
            }
        }

        function handleConnectionEstablished() {
            this.connection = connection;
            this.handler.setConnect(connection);

            this.handler.enterRoom();

            dispatch(connectionSuccess(connection, type));
            unsubscribe();
            this.connecting = true;
        }

        function unsubscribe() {
            connection.removeEventListener(
                JitsiConnectionEvents.CONNECTION_ESTABLISHED,
                handleConnectionEstablished);

            connection.removeEventListener(
                JitsiConnectionEvents.CONNECTION_FAILED,
                handleConnectionFailed);
        }
    }

    connect(config) {
        const connection = new JitsiMeetJS.JitsiConnection(null, null, config);
        
        // 연결 시도
        APP.store.dispatch(connectionWillConnect(connection, type));

        // add event (연결 성공, 실패, 끊김)
        this._handlerConnectionEvent(connection);

        // 연결 시작 
        connection.connect();
    }

    disconnect() {
        const connect = getConnection(APP.store.getState()["features/base/connection"], "jitsi");
        if (!connect) return;
        connect.disconnect();
    }

}

const jitsiConnection = new Connection();
export default jitsiConnection;